import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Header from "./components/Header";
import Presentacion from "./components/Presentacion";
import Education from "./components/Education";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import ContactForm from "./components/Contact";
import { Home, Code, FileText, Mail } from "lucide-react";

const App = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-2xl mx-auto w-full px-4 pt-8 pb-24">
        <Presentacion />
        <Education />
        <Projects />
        <Skills />
        <ContactForm />
      </main>
      <nav className="fixed bottom-0 left-0 right-0 bg-black/80 backdrop-blur-md border-t border-white/10 px-6 pb-6 pt-3 flex justify-center gap-12 z-50">
        <a
          href="#about"
          className="flex flex-col items-center gap-1 opacity-50 hover:opacity-100 transition"
        >
          <Home className="text-white text-2xl" />
          <span className="text-[10px] font-bold uppercase tracking-tighter text-white">
            Inicio
          </span>
        </a>
        <a
          href="#projects"
          className="flex flex-col items-center gap-1 opacity-50 hover:opacity-100 transition"
        >
          <Code className="text-white text-2xl" />
          <span className="text-[10px] font-bold uppercase tracking-tighter text-white">
            Proyectos
          </span>
        </a>
        <a
          href="#my-skills"
          className="flex flex-col items-center gap-1 opacity-50 hover:opacity-100 transition"
        >
          <FileText className="text-white text-2xl" />
          <span className="text-[10px] font-bold uppercase tracking-tighter text-white">
            Skills
          </span>
        </a>
        <a
          href="#contact"
          className="flex flex-col items-center gap-1 opacity-50 hover:opacity-100 transition"
        >
          <Mail className="text-white text-2xl" />
          <span className="text-[10px] font-bold uppercase tracking-tighter text-white">
            Mail
          </span>
        </a>
      </nav>
    </div>
  );
};

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
} else {
  console.error("Root element not found");
}
